import UpgradeAccountButton from '@/components/subscription/UpgradeAccountButton';
import { useSidebar } from '@/components/ui/sidebar';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useEntitlements } from '@/hooks/use-entitlements';
import { getTrialRemainingDays } from '@/lib/entitlements';
import { type ReactElement } from 'react';

const getTrialText = (remainingDays: number) => {
    if (remainingDays === 0) return 'Seu teste acaba hoje';
    if (remainingDays === 1) return '1 dia restante no teste';

    return `${remainingDays} dias restantes no teste`;
};

export default function SidebarUpgradeButton(): ReactElement {
    const { state } = useSidebar();
    const { entitlements } = useEntitlements();
    const isCollapsed = state === 'collapsed';
    const remainingTrialDays =
        entitlements?.status === 'trial' ? getTrialRemainingDays(entitlements.period_end) : null;
    const trialText =
        !isCollapsed && remainingTrialDays !== null ? getTrialText(remainingTrialDays) : null;

    const button = (
        <UpgradeAccountButton
            iconOnly={isCollapsed}
            className="w-full group-data-[collapsible=icon]:w-10"
        />
    );

    return (
        <div className="w-full group-data-[collapsible=icon]:flex group-data-[collapsible=icon]:justify-center">
            {isCollapsed ? (
                <Tooltip>
                    <TooltipTrigger asChild>{button}</TooltipTrigger>
                    <TooltipContent side="right" align="center">
                        Upgrade
                    </TooltipContent>
                </Tooltip>
            ) : (
                <div className="w-full space-y-2">
                    {button}
                    {trialText ? (
                        <p className="px-1 text-center text-xs font-medium leading-5 text-muted-foreground">
                            {trialText}
                        </p>
                    ) : null}
                </div>
            )}
        </div>
    );
}
